import { useState } from "react";

import { Loader, NotificationType } from "@transfr-inc/dashboard-components";

import { GenericError } from "@components/utils/notification.constants";
import { UNIVERSAL_MENU_NAME } from "@constants/template-types";
import { services } from "@src/dependencies";
import { useNotification } from "@src/hooks";

import { MenuBuilderCategories } from "../components/menu-builder/layout/menu-builder.categories";
import { MenuBuilderHeader } from "../components/menu-builder/layout/menu-builder.header";

import "./categories.section.scss";

export const CategoriesSection = ({ menu, mergeCategoryData }) => {
  const { addNotification } = useNotification();
  const { menuBuilderService } = services;
  const [loading, setLoading] = useState(false);

  const menuEditable = menu.name !== UNIVERSAL_MENU_NAME;

  const onEditCategoriesHandler = async (data) => {
    setLoading(true);
    const { id: menuId } = menu;
    const categoryData = data.map((c) => {
      const { categoryId, orderNumber, isVisible } = c;
      return { categoryId, orderNumber, isVisible };
    });

    try {
      const updatedCategories = await menuBuilderService.updateCategories(
        menuId,
        categoryData,
      );
      mergeCategoryData(updatedCategories);
    } catch {
      showNotification(NotificationType.error, GenericError);
    }
    setLoading();
  };

  const showNotification = (type, message, icon) => {
    addNotification({ type, message, icon });
  };

  return (
    <div className="menu-builder-container">
      {loading && <Loader overlay fixed />}
      <MenuBuilderHeader
        categories={menu.categories}
        onEditCategoriesClick={onEditCategoriesHandler}
        menu={menu}
        showNotification={showNotification}
        menuEditable={menuEditable}
      ></MenuBuilderHeader>
      <MenuBuilderCategories
        categories={menu.categories}
        menu={menu}
        menuEditable={menuEditable}
      />
    </div>
  );
};
